module.exports = __webpack_public_path__ + "static/media/3dcamera_gray.cd1ac9b8.png";